import { useContext } from 'react'
import userId from '../context/userId'

const useUserId = () => {
  const context = useContext(userId.context)

  if (context === undefined) {
    throw new Error('useUserId must be used within a UserIdProvider')
  }

  return context
}

export default useUserId
